// extracted by mini-css-extract-plugin
export default {"navbarHideable":"navbarHideable_bChn","navbarHidden":"navbarHidden_zsXl"};